<mat-card-content>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
            <mat-card class="mb-25 tagus-card">
                <mat-card-header> </mat-card-header>
                <mat-card-content>
                    <div class="empty-state">
                        <div class="empty-state__content">
                            <div class="empty-state__icon">
                                <img src="assets/img/no-data.png" alt="" />
                            </div>
                            <div class="empty-state__message">
                                {{ message }}
                            </div>
                            <div class="empty-state__help">
                                <!-- Add a new record by simpley clicking the button on top right side. -->
                            </div>
                        </div>
                    </div>

                    <!-- <div class="credit">Illustration by <a href="https://icons8.com/" target="_blank">ICONS8</a>.</div> -->
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</mat-card-content>
